@if (order$ | async; as order) {
  <cx-order-overview [order]="order" [isOrderHistoryList]="true"></cx-order-overview>
}
